import '../node_modules/bootstrap/scss/bootstrap.scss'

import {useLocation} from 'react-router-dom';

import { Link } from "react-router-dom";

function Breadcrumbs() {

  const location = useLocation();

  const section = location.pathname.toString().split('/');

  // console.dir(section);

    return (
      
      <div className="col d-flex flex-row breadcrumbs-container">
        {section[1] === 'productos'? <Link className="d-flex flex-row" to="/productos/" relative="path"><span className="chevron">></span><span className="ps-1 breadcrumb">Productos</span></Link> : ''}
        {section[1] === 'digital'? <Link className="d-flex flex-row" to="/digital/" relative="path"><span className="chevron">></span><span className="ps-1 breadcrumb">Digital</span></Link> : ''}
        {section[2] === 'pisos'? <Link className="d-flex flex-row" to="/productos/pisos" relative="path"><span className="chevron">></span><span className="ps-1 breadcrumb">Pisos, Pavimentos y OOCC</span></Link> : ''}
        {section[2] === 'vivienda'? <Link className="d-flex flex-row" to="/productos/vivienda" relative="path"><span className="chevron">></span><span className="ps-1 breadcrumb">Vivienda, Edificación y Productividad</span></Link> : ''}
        {section[2] === 'arquitectonicos'? <Link className="d-flex flex-row" to="/productos/arquitectonicos" relative="path"><span className="chevron">></span><span className="ps-1 breadcrumb">Arquitectónicos y Sostenibilidad</span></Link> : ''}
      </div>

    );


}

export default Breadcrumbs;
